import type { RouteRecordRaw } from "vue-router";

export const routes = [
  {
    path: "/s1-external-api-log/:logId(\\d+)?",
    name: "S1 External API Log",
    component: () => import("./s1ExternalApiLog.vue"),
  },
  {
    path: "/error-reports/:reportType(customer-errors|bug-reports)?/:reportId(\\d+)?",
    name: "Error Reports",
    component: () => import("./errorReports.vue"),
  },

  {
    path: "/batch-tasks-and-logs",
    name: "Batch Tasks & Logs",
    component: () => import("./batchTasksAndLogs.vue"),
  },
  {
    path: "/log-watch-config",
    name: "Log Watches",
    component: () => import("./logWatchConfig.vue"),
  },
  {
    path: "/performance-reporting",
    name: "Performance Reporting",
    component: () => import("./performanceReporting.vue"),
  },
] satisfies RouteRecordRaw[];
